<template>
  <el-form
    :label-position="labelPosition"
    :label-width="labelWidthFilter"
    :model="model"
    :rules="rules"
    @submit.native.prevent="doFilter"
    class="filter"
    ref="form"
  >
    <el-row>
      <el-col v-if="hasPermissionToAuditLogs" :lg="12" :md="16" :sm="24">
        <el-form-item
          :label="fields.id.label"
          :prop="fields.id.name"
        >
          <el-input v-model="model[fields.id.name]" />
        </el-form-item>
      </el-col>

      <el-col v-if="hasPermissionToAuditLogs" :lg="12" :md="16" :sm="24" style="margin-bottom: -0.41px;">
        <el-form-item
          :label="fields.createdAtRange.label"
          :prop="fields.createdAtRange.name"
        >
          <el-date-picker type="datetimerange" v-model="model[fields.createdAtRange.name]"></el-date-picker>
        </el-form-item>
      </el-col>

      <el-col :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.title.label" :prop="fields.title.name">
          <el-input v-model="model[fields.title.name]" />
        </el-form-item>
      </el-col>

      <el-col :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.description.label" :prop="fields.description.name">
          <el-input v-model="model[fields.description.name]" />
        </el-form-item>
      </el-col>

      <el-col :lg="12" :md="16" :sm="24" style="margin-bottom: -0.41px;">
        <el-form-item :label="fields.dateRange.label" :prop="fields.dateRange.name">
          <el-date-picker type="datetimerange" v-model="model[fields.dateRange.name]"></el-date-picker>
        </el-form-item>
      </el-col>

      <el-col :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.hour.label" :prop="fields.hour.name">
          <el-input v-model="model[fields.hour.name]" />
        </el-form-item>
      </el-col>

      <el-col :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.duration.label" :prop="fields.duration.name">
          <el-input v-model="model[fields.duration.name]" />
        </el-form-item>
      </el-col>

      <el-col :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.location.label" :prop="fields.location.name">
          <el-input v-model="model[fields.location.name]" />
        </el-form-item>
      </el-col>

      <el-col :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.status.label" :prop="fields.status.name">
          <el-input v-model="model[fields.status.name]" />
        </el-form-item>
      </el-col>

      <el-col :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.team.label" :prop="fields.team.name">
          <app-autocomplete-one-input
            :fetchFn="fields.team.fetchFn"
            v-model="model[fields.team.name]"
          ></app-autocomplete-one-input>
        </el-form-item>
      </el-col>
    </el-row>

    <div class="filter-buttons">
      <el-button :disabled="loading" @click="doFilter" icon="el-icon-fa-search" type="primary">
        <app-i18n code="common.search"></app-i18n>
      </el-button>

      <!-- <el-button :disabled="loading" @click="doResetFilter" icon="el-icon-fa-undo">
        <app-i18n code="common.reset"></app-i18n>
      </el-button> -->
    </div>
  </el-form>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { mapGetters, mapActions } from 'vuex';
import { FilterSchema } from '@shared/form/filter-schema';
import { TrainingModel } from '@modules/training/training-model';

const { fields } = TrainingModel;

const filterSchema = new FilterSchema([
  fields.id,
  fields.createdAtRange,
  fields.title,
  fields.description,
  fields.dateRange,
  fields.hour,
  fields.duration,
  fields.location,
  fields.status,
  fields.team,
]);

export default {
  name: 'app-training-list-filter',

  data() {
    return {
      rules: filterSchema.rules(),
      model: {},
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthFilter: 'layout/labelWidthFilter',
      loading: 'training/list/loading',
      filter: 'training/list/filter',
    }),
    
    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    fields() {
      return fields;
    },
  },

  async mounted() {
    this.model = filterSchema.initialValues(
      this.filter,
      this.$route.query,
    );

    return this.doFilter();
  },

  methods: {
    ...mapActions({
      doReset: 'training/list/doReset',
      doFetch: 'training/list/doFetch',
    }),

    async doResetFilter() {
      this.model = filterSchema.initialValues();
      this.$refs.form.clearValidate();
      return this.doReset();
    },

    async doFilter() {
      try {
        await this.$refs.form.validate();
        this.$refs.form.clearValidate();
      } catch (error) {
        return;
      }

      const filter = filterSchema.cast(this.model);
      return this.doFetch({
        filter,
      });
    },
  },
};
</script>

<style>
</style>
